import { useEffect, useState, useRef } from "react";

export default function useWebRTC({ onTrack, onDataChannel, answer, sendIce, onOpened, onClosed }) {
  const peerConnectionRef = useRef(null);
  const [isConnected, setConnected] = useState(false);

  function handleOffer(offer) {
    const description = { type: "offer", sdp: offer };
    const peerConnection = peerConnectionRef.current;
    return peerConnection.setRemoteDescription(description).then(() => {
      sendAnswer(peerConnection);
    });
  }

  function sendAnswer(peerConnection) {
    return peerConnection
      .createAnswer()
      .then((answer) => peerConnection.setLocalDescription(answer))
      .then(function () {
        console.debug("SENDING ANSWER", peerConnection.localDescription.sdp);
        answer(peerConnection.localDescription.sdp);
      })
      .catch(function (error) {
        console.error(error);
      });
  }

  useEffect(() => {
    // TODO: This information should be protected by the backend and given only when logged-in
    const iceServers = [
      {
        urls: ["stun:stun.l.google.com:19302"],
      },
      {
        urls: ["turn:160.98.47.137:8000"],
        username: "rosas",
        credential: "9xaYw3wns6wCfYJ4",
      },
    ];

    const config = {
      sdpSemantics: "unified-plan",
      bundlePolicy: "max-bundle",
      iceServers: iceServers,
    };

    const peerConnection = new RTCPeerConnection(config);
    peerConnectionRef.current = peerConnection;

    peerConnection.onicecandidate = (e) => {
      console.debug("GOT ICE CANDIDATE", e.candidate);
      if (e.candidate) {
        sendIce({ candidate: e.candidate.candidate, mid: e.candidate.sdpMid });
      }
    };

    // register some listeners to help debugging
    peerConnection.onicegatheringstatechange = () =>
      console.debug(`ICE grathering state change: ${peerConnection.iceGatheringState}`);
    peerConnection.oniceconnectionstatechange = () =>
      console.debug(`ICE connection state change: ${peerConnection.iceConnectionState}`);
    peerConnection.onsignalingstatechange = () =>
      console.debug(`Signaling state change: ${peerConnection.signalingState}`);

    peerConnection.ontrack = onTrack;
    peerConnection.ondatachannel = onDataChannel;
    peerConnection.onconnectionstatechange = () => {
      console.log("connection state change");
      console.log(peerConnection.connectionState);
      switch (peerConnection.connectionState) {
        case "connected":
          setConnected(true);
          onOpened();
          break;
        case "disconnected":
        case "failed":
          // One or more transports has terminated unexpectedly or in an error
          setConnected(false);
          break;
        case "closed":
          // The connection has been closed
          setConnected(false);
          onClosed();
          break;
        default:
          break;
      }
    };

    return () => {
      peerConnection.close();
    };
    // The comment below supresses a warning, the array [] is empty on purpose to
    // prevent resets of the connection when callback methods change.

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { handleOffer, isConnected };
}
